/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-06-04 16:42:03
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\logistics\sku\service.ts
 */
import request from '@/utils/request'
import {TableListQueryParams, SkuInfoParams} from './data.d'

export async function getSkuPageList(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/getSkuPageList',
        method: 'POST',
        data: params,
    });
}

export async function saveSku(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/saveSku',
        method: 'POST',
        data: params,
    });
}

export async function skuInfo(params:SkuInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/skuInfo',
        method: 'POST',
        data: params,
    });
}

export async function updateSku(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/updateSku',
        method: 'POST',
        data: params,
    });
}

export async function deleteSku(params:SkuInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/deleteSku',
        method: 'DELETE',
        data: params,
    });
}
